import { useCallback, useMemo, useState } from 'react'
import { filterTabsByPermissions, useTabObjectLogic } from '../../../utils/hooks/useTabLogic'
import { getAntiUnsave } from '../../../utils/reducers/getters'
import { showAntiUnsaveModal } from '../../../utils/reducers/reduxDispatch'
import { EditCardTabsLeftBarDiv } from '../../EditCardTabs'
import { TabsInfo } from '../../EditCardTabs/types'
import Modal, { CloseLateralModal } from '../../Modal'
import { ModalComponentProps } from '../types'
import { UserPermissionsSingle } from '../../CreateRoutering/types'
import LoadingSpinner from '../../LoaderDecider/LoadingSpinner'

type ModalTabsProps = TabsInfo & ModalComponentProps & ModalTabsLogicProps & {
    className?: string
    extraComponentData?: { [key: string]: any }
    userPermissions: UserPermissionsSingle
    isLoading?: boolean
}

const ModalTabs: React.FC<ModalTabsProps> = ({ className, tabs, tab, extraComponentData, userPermissions, isLoading, skipAntiUnsaveItems, ...rest }) => {
    const {changeTab, tabActive } = useModalTabsLogic({tab, skipAntiUnsaveItems})
    const tabsFiltered = useMemo(() => filterTabsByPermissions(tabs, userPermissions), [tabs, userPermissions])
    const { active, ComponentFromTab } = useTabObjectLogic(tabsFiltered, tabActive)
    if (!tabsFiltered || !Object.keys(tabsFiltered).length) {
        return null
    }
    return (
        <Modal className={'h-full modal_tabs flex ' + (className || '')} opened={true} setOpened={rest.setOpened} onClickOut={false}>
            <EditCardTabsLeftBarDiv tabs={tabsFiltered} tab={active} onClick={changeTab}/>
            <div className='flex flex-col flex-auto modal_tab_inner w-1'>
                <CloseLateralModal {...{ setOpened: rest.setOpened }} />
                {isLoading ? <LoadingSpinner /> : <ComponentFromTab {...rest} {...extraComponentData} userPermissions={tabsFiltered[active].userPermission} /> }
            </div>
        </Modal>
    )
}

interface ModalTabsLogicProps {
    tab?: string | number
    skipAntiUnsaveItems?: string[]
}

const useModalTabsLogic = ({tab, skipAntiUnsaveItems}: ModalTabsLogicProps) => {
    const [tabActive, setTabActive] = useState(tab)
    const changeTab = useCallback((tabId: any) => {
        const errors = getAntiUnsave()
        const cleanAntiUnsave = skipAntiUnsaveItems ? {} : errors
        if(skipAntiUnsaveItems){
            for (const key in errors) {
                if(!skipAntiUnsaveItems.includes(key)){
                    cleanAntiUnsave[key] = errors[key]
                }
            }
        }
        if (Object.keys(cleanAntiUnsave).length){
            showAntiUnsaveModal(() => setTabActive(tabId))
        } else {
            setTabActive(tabId)
        }
    }, [skipAntiUnsaveItems])
    return {changeTab, tabActive}
}

export default ModalTabs